import { observable, action } from "mobx";
import axios from "axios";

export default class FormStore {
    @observable submitted;
    @observable submitMensagemErro;
    @observable acaoEnviada;
    @observable solicitando;


    constructor() {
        this.acaoEnviada = false;
        this.submitted = false;
        this.submitMensagemErro = "";
        this.solicitando = false;
    }


    toggleAcaoEnviada() {
        this.acaoEnviada = !this.acaoEnviada;
    }

    setSubmitted(value) {
        this.submitted = value;
    }

    setSubmitMensagemErro(value) {
        this.submitMensagemErro = value;
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/stores/FormStore.js